import { useSearchParams } from "react-router";

import type { NavigationCategory } from "~/components/hec-header/mobile-nav/types";
import { CAT_PARAM } from "~/routes/fsastore-spender/spender-page";

import { type Chip, defaultChipId, selectedChip } from "./chips";

/** `?cat=` as the selected chip, and its setter: the only state the chip row and grid share. */
export function useChipParam(
  categories: readonly NavigationCategory[],
  chips: readonly Chip[],
) {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedId = selectedChip(
    searchParams.get(CAT_PARAM),
    categories,
    chips,
  );

  const select = (id: string) => {
    if (id === selectedId) return;
    setSearchParams(
      prev => {
        if (id === defaultChipId(chips)) prev.delete(CAT_PARAM);
        else prev.set(CAT_PARAM, id);
        return prev;
      },
      { replace: true, preventScrollReset: true },
    );
  };

  return [selectedId, select] as const;
}
